import { useCallback, useRef, useState } from "react";
import { IGif } from "@/common/services/types";
import { metricsBus, EventSource } from "@/common/buses";
import { useAppStore } from "@/common/store/appStore";
import { useUserStore } from "@/common/store/userStore";
import { useAnalyticsStore } from "@/common/store/analyticsStore";

interface UseGifMetrics {
  position: number;
}

export const useGifMetrics = ({ position }: UseGifMetrics) => {
  const viewedGifIds = useRef<string[]>([]);
  const isFullScreen = useAppStore((state) => state.isFullScreen);
  const currentUser = useUserStore((state) => state.currentUser);
  const eventSource = useAnalyticsStore((state) => state.eventSource);
  const gifContext = useAnalyticsStore((state) => state.gifContext);

  const [playCount, setPlayCount] = useState<number>(0);

  const sendGifView = useCallback((gif: IGif) => {
    if (viewedGifIds.current.indexOf(gif.id) === -1) {
      metricsBus.emit("gifView", {
        gifId: gif.id,
        tags: gif.tags,
        source: eventSource?.name ?? EventSource.Other,
        sourceId: eventSource?.id ?? null,
        position: position,
        boosted: !!gif.cta,
        userName: currentUser?.username,
        fullscreen: isFullScreen,
        orientation: screen.orientation?.type,
        context: gifContext,
        reason: gif.cta?.showReason ?? null,
      });

      viewedGifIds.current.push(gif.id);
    }
  }, [position, eventSource, isFullScreen, currentUser]);

  const incrementPlayCount = useCallback(() => {
    setPlayCount((count) => count + 1);
  }, []);

  return {
    sendGifView,
    playCount,
    incrementPlayCount
  };
};
